import { h, Component } from "preact";
import { css } from "emotion";

import InputWrapper from "./InputWraper";

const inputStyle = css({
  appearance: "none",
  width: "100%",
  borderRadius: 4,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "#8D949E",
  backgroundColor: "#f9f9fa",
  fontSize: 16,
  padding: 12,
  "@media(max-width: 600px)": {
    width: "100%",
    height: 36,
    fontSize: 14
  }
});

const InputField = ({
  name,
  type,
  placeholder,
  label,
  input,
  autocomplete,
  meta: { touched, error }
}) => {
  return (
    <InputWrapper touched={touched} error={error} label={label}>
      <input
        name={input.name}
        autocomplete={autocomplete}
        {...input}
        type={type}
        placeholder={placeholder}
        type={type}
        data-cy={`${input.name} input`}
        aria-label={`${input.name} input`}
        className={inputStyle}
      />
    </InputWrapper>
  );
};

export default InputField;
